export default function isLocalhost() {
  const hostname = window.location.hostname;
  return (
    hostname === 'localhost' ||
    hostname === '127.0.0.1' ||
    hostname === 'cruwi-creators-app-staging.herokuapp.com'
  );
}
